import { doc, runTransaction, serverTimestamp, deleteField } from 'firebase/firestore';
import { db } from './firebase';
import { stableStringify } from '../utils/stableJson';
import { uploadApprovalBlockedReason } from '../utils/workspaceApproval';

const APPROVAL_FIELDS = [
  'upload_id', 'prefix', 'name', 'pack_attributes', 'pre_converted_prefix',
  'triage', 'allocations', 'approved_at',
];

// Keep the person's confirmed destinations. A moved or changed member is skipped;
// it must not change the meaning of that confirmation or fail its siblings.
export async function approveWorkspaceFiles(companyId, uploadId, entries) {
  const uploadRef = doc(db, `users/${companyId}/uploads/${uploadId}`);
  const refs = entries.map(({ file }) => doc(db, `users/${companyId}/unallocated_files/${file.id}`));
  return runTransaction(db, async transaction => {
    const uploadSnap = await transaction.get(uploadRef);
    const snapshots = await Promise.all(refs.map(ref => transaction.get(ref)));
    const upload = uploadSnap.exists() ? uploadSnap.data() : null;
    const batchReason = upload ? uploadApprovalBlockedReason(upload) : 'The upload no longer exists.';
    const approved = [];
    const skipped = [];
    snapshots.forEach((snapshot, index) => {
      const entry = entries[index];
      const current = snapshot.exists() ? snapshot.data() : null;
      let reason = batchReason;
      if (!reason && !current) reason = 'The file no longer exists.';
      if (!reason && current.status !== 'pending') reason = 'The file is no longer awaiting approval.';
      if (!reason && (current.upload_id !== uploadId || upload.raw_manifest?.[entry.file.id] !== 'pending')) {
        reason = 'The file is no longer a pending member of this upload.';
      }
      if (!reason && APPROVAL_FIELDS.some(field => (
        stableStringify(current[field] ?? null) !== stableStringify(entry.file[field] ?? null)
      ))) reason = 'The file or its proposal changed. Review it again.';
      if (reason) {
        skipped.push({ file: entry.file, reason });
        return;
      }
      transaction.update(refs[index], {
        allocations: entry.action, status: 'approved', approved_at: serverTimestamp(),
        error: deleteField(), auto_allocated: deleteField(),
      });
      approved.push(entry);
    });
    return { approved, skipped };
  });
}
